/** Compte client auquel est rattachée la copie d'un projet. */
export enum ProjectDuplicateTarget {
  /** Client actuellement identifié. */
  SameAccount,
  /** Autre client, choisi par recherche. */
  OtherAccount,
}
